import React from 'react'
import { t } from '@lingui/macro'

import GenericAccessModal, { AccessModalMode } from './GenericAccessModal'
import { IMembersSelectorMembers } from '../../../components/common/members-selector/MembersSelector'
import {
  usePathwayAddUserMutation,
  usePathwayAddGroupMutation,
  usePathwayShareWithGroupsMutation,
  usePathwayShareWithUsersMutation
} from './PathwayShareModal.codegen'

interface IPathwayShareModalProps {
  pathwayId: number
  show: boolean
  mode: AccessModalMode
  onCancel?: () => void
  onSubmitted?: () => void
  membersSelected?: IMembersSelectorMembers
}

const PathwayShareModal = (props: IPathwayShareModalProps) => {
  const [pathwayAddUser] = usePathwayAddUserMutation()
  const [pathwayAddGroup] = usePathwayAddGroupMutation()
  const [pathwayShareWithGroups] = usePathwayShareWithGroupsMutation()
  const [pathwayShareWithUsers] = usePathwayShareWithUsersMutation()

  const { mode, pathwayId } = props

  return (
    <GenericAccessModal
      header={
        mode === AccessModalMode.ENROL_AND_ACCESS
          ? t`Share this pathway`
          : t`Add people and groups to pathway access`
      }
      subheader={
        mode === AccessModalMode.ENROL_AND_ACCESS
          ? t`Creates trackable pathway enrolments`
          : t`Gives users access to this pathway, but does not create trackable enrolments`
      }
      shareWithUsers={async (variables) => {
        await pathwayShareWithUsers({
          variables: {
            pathwayId,
            variables
          }
        })
      }}
      shareWithGroups={async (variables) => {
        await pathwayShareWithGroups({
          variables: {
            pathwayId,
            variablesGroups: variables
          }
        })
      }}
      addUser={async (userId) => {
        await pathwayAddUser({
          variables: {
            pathwayId,
            input: {
              userId: userId
            }
          }
        })
      }}
      addGroup={async (groupId) => {
        await pathwayAddGroup({
          variables: {
            pathwayId,
            input: {
              groupId
            }
          }
        })
      }}
      {...props}
    />
  )
}

export default PathwayShareModal
